
    /**
    * 新政活动
    **/
      
  import request, {AxiosPromise} from '@utils/request'
  /**
 * ActivitySaveParam :ActivitySaveParam
 */
export class IReqid13280 {
  id?: {};
  activityNo?: {};
  activityName: {};
  /**
   * String
   */
  bannerImage: {}[];
  shelfTime: {};
  offshelfTime: {};
  creator: {};
  isDeleted?: {};
  sortNum?: {};
  updator?: {};
  updateTime?: {};
  status?: {};
  createTime?: {};
}
  /**
 * YResult :YResult
 */
export class IResid13280 {
  code?: {};
  msg?: {};
  success?: {};
  exceptionMsg?: {};
}
  type Serve<T, G> = (data?: T) => AxiosPromise<G>
  const http: Serve<IReqid13280, IResid13280 > = (data?) =>  request({
        method: 'POST',
        url: '/admin/activity/save',
        data: data
      }) 
  export default http